import bestserviceIcon from 'assets/images/bestservice.png';
import mvpIcon from 'assets/images/mvp.png';
import defaultAvatar from 'assets/images/default-avatar.png';
import sportsmanshipIcon from 'assets/images/sportsmanship.png';
import React, { Component } from "react";
import Modal from 'react-modal';
import { Badge, Button, Card, CardBody, CardHeader, CardImg, CardTitle, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { API_URL } from "../Constants"; // Import API_URL
import classes from './Team.css';
import './Team.css';
import TeamModal from './TeamModal';
import cap from "../../assets/images/cap.png";


export class UserCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            data: null,
            profileUrl: null,
            showProfile: false
        };

        this.playersHandler = this.playersHandler.bind(this);
    }
    componentWillMount() {
        Modal.setAppElement('footer');
    }

    closeModel = () => {
        this.setState(prevState => ({
            modal: !prevState.modal,
            players: null,
            schedule: null,
            games: null,
            profileUrl: null,
            showProfile: false
        }));
        return null;
    }

    closeShowProfileModel = () => {
        this.setState(prevState => ({
            ...prevState,
            profileUrl: null,
            showProfile: !prevState.showProfile
        }));
        return null;
    }

    gameHandler = () => {
        const { id } = this.props.team;
        fetch(`${API_URL}/app/api/v1/games?filter=homeTeam.id==${id},visitorTeam.id==${id}`)
            .then(results => {
                return results.json();
            }).then(resp => {
                this.setState(prevState => ({
                    modal: !prevState.modal,
                    players: null,
                    schedule: null,
                    profileUrl: null,
                    showProfile: false,
                    games: resp.map((game) => {
                        let gameInfo = {
                            gameId: game.id,
                            gameNo: game.gameNo,
                            homeTeam: game.homeTeamName,
                            visitorTeam: game.visitorTeamName,
                            status: game.status,
                            homeScore: game.homeTeamScore,
                            visitorScore: game.visitorTeamScore,
                            gameCourtNo: game.courtNo,
                            gameRound: game.round
                        }
                        return gameInfo;
                    })
                }))
            });
    }

    scheduleHandler = () => {
        const { id } = this.props.team;
        fetch(`${API_URL}/app/api/v1/schedules?filter=homeTeam.id==${id},visitorTeam.id==${id}`)
            .then(results => {
                return results.json();
            }).then(resp => {
                this.setState(prevState => ({
                    modal: !prevState.modal,
                    players: null,
                    games: null,
                    profileUrl: null,
                    showProfile: false,
                    schedule: resp.map((teamSchedule) => {
                        return teamSchedule
                    })
                }))
            });
    }
    playersHandler = (teamName) => {
        fetch(`${API_URL}/app/api/v1/teams?filter=division.id==${this.props.divisionId}`)
            .then(results => {
                return results.json();
            }).then(resp => {
                this.setState(prevState => ({
                    modal: !prevState.modal,
                    schedule: null,
                    games: null,
                    showProfile: false,
                    players: resp.map((team) => {
                        if (team.name === teamName) {
                            return team.teamPlayers.map((player) => {
                                return <Card style={{ padding: '4px', 'margin-bottom': '5px' }}>
                                    <CardHeader tag="h6">{player.firstName} {player.lastName} { player.playerRole === 'captain' && <img src={cap} class="custom-cap custom-img" width="25" height="25" /> }</CardHeader>
                                    <CardBody>
                                        <div className="d-flex align-items-center">
                                            {/* <div className="me-auto">
                                            <CardTitle className="px-4 mb-2" role="button"><CardImg width="24px" src={mvpIcon} onClick={() => this.voteMVP(this.props.team.id, player.id)} /> {player.mvpVotes != null ? player.mvpVotes : 0}</CardTitle>
                                                <CardTitle className="px-4 mb-2" role="button"><CardImg width="24px" src={bestserviceIcon} onClick={() => this.voteBestService(this.props.team.id, player.id)} /> {player.bestServerVotes != null ? player.bestServerVotes : 0} </CardTitle>
                                                <CardTitle className="px-4 mb-2" role="button"><CardImg width="24px" src={sportsmanshipIcon} onClick={() => this.voteSportsmanship(this.props.team.id, player.id)} /> {player.sportsmanshipVotes != null ? player.sportsmanshipVotes : 0} </CardTitle>
                                            </div> */}
                                            <div className="p-3">
                                                {player.profilePic && <CardImg role="button" className="rounded-circle" width={75} height={75} src={player.profilePic} onClick={()=> this.viewProfile(player.profilePic)} />}
                                                {!player.profilePic && <CardImg role="button" className="rounded-circle" width={75} height={75} src={defaultAvatar} onClick={()=> this.viewProfile(defaultAvatar)} />}
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            })
                        } else {return ""}
                    })
                }));
                // resp.map(team => console.log(team.scheduleDate));
            });
    }

    voteMVP(teamId, playerId) {
        // fetch(`${API_URL}/app/api/v1/teams/${teamId}/team-players/${playerId}/vote-mvp`, {
        //     method: 'PUT'
        // }).then(resp => {
        //     this.setState(() => ({
        //         players: this.state.players.map((player) => {
        //             return player;
        //         })

        //     }));
        //     alert("Thank you for voting")
        //     this.closeModel();

        // });
    }

    voteBestService(teamId, playerId) {
        // fetch(`${API_URL}/app/api/v1/teams/${teamId}/team-players/${playerId}/vote-best-server`, {
        //     method: 'PUT'
        // }).then(resp => {
        //     this.setState(() => ({
        //         players: this.state.players.map((player) => {
        //             return player;
        //         })

        //     }));
        //     alert("Thank you for voting")
        //     this.closeModel();

        // });
    }

    voteSportsmanship(teamId, playerId) {
        // fetch(`${API_URL}/app/api/v1/teams/${teamId}/team-players/${playerId}/vote-sportsmanship`, {
        //     method: 'PUT'
        // }).then(resp => {
        //     alert("Thank you for voting")
        //     this.closeModel();

        // });
    }

    viewProfile(profileUrl){
        this.setState(prevState => ({
            modal: prevState.modal,
            players: prevState.players,
            schedule: prevState.schedule,
            games: prevState.games,
            profileUrl: profileUrl,
            showProfile: !prevState.showProfile
        }))
    }
    render() {
        return (
            <div>
                <ListGroup>
                    <ListGroupItem style={{ backgroundColor: '#0A2E7C', color: '#FFF' }}>
                        {this.props.team.name}<Badge pill>{this.props.team.teamNo}</Badge>
                    </ListGroupItem>
                    <div class="btn-group">
                            <Button color="primary" onClick={() => this.scheduleHandler()}>Schedule</Button>&nbsp;&nbsp;
                            <Button color="primary" onClick={() => this.gameHandler()}>Game</Button>&nbsp;&nbsp;&nbsp;
                            <Button color="primary" onClick={() => this.playersHandler(this.props.team.name)} >Player</Button>&nbsp;&nbsp;
                        </div>
                </ListGroup>
                <Modal isOpen={this.state.modal} onRequestClose={() => this.playersHandler()} className={classes.Modal} style={{padding: "0px"}}>
                    
                    <div className="row mb-3 sticky-top m-0 bg-white custom-top">
                        <div className="col ms-0 ps-0">
                            <h3 className="my-3">Squad</h3>
                        </div>
                        <div className="col text-right me-0 pe-0">
                            <Button className="my-3" color="primary" onClick={() => this.closeModel()}> X Close </Button>
                        </div>
                    </div>
                    <div className="p-4">
                        <TeamModal players={this.state.players} schedule={this.state.schedule} games={this.state.games} />
                    </div>
                </Modal>

                <Modal isOpen={this.state.showProfile} onRequestClose={() => this.playersHandler()} >
                    <div>
                        <div>
                            { this.state.profileUrl && <CardImg width={250} height={350} src={this.state.profileUrl} /> }
                            { !this.state.profileUrl && <CardImg width={250} height={350} src={defaultAvatar} /> }
                        </div>
                        <div>
                            <Button color="primary" className="mt-4" onClick={() => this.closeShowProfileModel()}> X Close </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default UserCard;


// WEBPACK FOOTER //
// ./src/components/TileIcon/UserCard.js